import { Nilable } from "../shared/utils/Nullable";

// DTO vs Hardcodear los NSEs como están los géneros y edades?
// con el endpoint se updatea el backend solamente, además de que son bastantes para hardcodear

export interface INSELevelsDTO {
    nse_by_country: INSECountryLevelsDTO[];
}

export class NSELevelsDTO {
    public NSEPorPais: NSECountryLevelsDTO[] = [];

    constructor(json: Nilable<INSELevelsDTO> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: INSELevelsDTO) {
        this.NSEPorPais = json.nse_by_country.map(
            nse_by_country => new NSECountryLevelsDTO(nse_by_country));
    }
}


export interface INSECountryLevelsDTO {
    country: string;
    levels: string[];
}

export class NSECountryLevelsDTO {
    country = "";
    levels: string[] = [];

    constructor(json: Nilable<INSECountryLevelsDTO> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: INSECountryLevelsDTO) {
        this.country = json.country;
        this.levels = json.levels;
    }
}
